export const loginFormConfig = [
  {
    name: "email",
    type: "email",
    label: "Email",
    placeholder: "Enter your email",
    required: true,
    autoComplete: "off",
    validate: (value) =>
      !/\S+@\S+\.\S+/.test(value) ? "Email is invalid" : null,
  },
  {
    name: "password",
    type: "password",
    label: "Password",
    placeholder: "Enter your password",
    autoComplete: "off",  
    required: true,
  },
];
